import { render, staticRenderFns } from "./ListIntegrations.vue?vue&type=template&id=31fbdd90&scoped=true"
import script from "./ListIntegrations.vue?vue&type=script&lang=js"
export * from "./ListIntegrations.vue?vue&type=script&lang=js"
import style0 from "./ListIntegrations.vue?vue&type=style&index=0&id=31fbdd90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fbdd90",
  null
  
)

export default component.exports